import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider.jsx';
import { FullScreenLoader } from '../components/ui/FullScreenLoader.jsx';
import { StoreSelectPage } from '../pages/StoreSelectPage.jsx';

/**
 * Route guard. Renders the matching child routes when the principal
 * is authenticated and (optionally) carries one of the allowed roles.
 *
 * Loading state while the AuthProvider is hydrating the /me call
 * shows a full screen spinner instead of flashing the login page.
 */
export function RequireAuth({ allow }) {
  const { status, role, needsStoreSelection } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullScreenLoader />;
  if (status !== 'authenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  // A scoped user assigned to several stores must pick one before reaching
  // any protected surface, so store specific features have a single store.
  if (needsStoreSelection) {
    return <StoreSelectPage />;
  }
  if (allow && allow.length > 0 && !allow.includes(role)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
